import { List } from 'immutable';

export function request(state, { id, data }) {
    let opened = state.get('opened') || List();

    if (!opened.contains(id) || !data) {
        state = state.removeIn(['history', id]);
    } else {
        state = state.mergeIn(['history', id], data);
    }

    return state;
}
